(function () {
  var mainbar = document.querySelector('[data-ls-mainbar]');
  if (mainbar) {
    var onScroll = function () {
      mainbar.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function setupOverlay(toggle, overlay, closeSelector, onOpen) {
    if (!toggle || !overlay) return;
    var open = function () {
      overlay.hidden = false;
      document.body.classList.add('ls-no-scroll');
      toggle.setAttribute('aria-expanded', 'true');
      if (onOpen) onOpen();
    };
    var close = function () {
      overlay.hidden = true;
      document.body.classList.remove('ls-no-scroll');
      toggle.setAttribute('aria-expanded', 'false');
    };
    toggle.addEventListener('click', open);
    overlay.querySelectorAll(closeSelector).forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });
  }

  var searchToggle = document.querySelector('[data-ls-search-toggle]');
  var searchModal = document.querySelector('[data-ls-search-modal]');
  if (searchToggle && searchModal) {
    var input = searchModal.querySelector('[data-ls-search-input]');
    var results = searchModal.querySelector('[data-ls-search-results]');
    setupOverlay(searchToggle, searchModal, '[data-ls-search-close]', function () {
      requestAnimationFrame(function () { input.focus(); });
    });

    var debounce;
    var formatPrice = function (value) {
      var n = parseFloat(value);
      if (isNaN(n)) return '';
      return n.toLocaleString('ro-RO', { maximumFractionDigits: 0 }) + ' lei';
    };
    var escapeHtml = function (s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    };

    input.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = input.value.trim();
      if (q.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }
      debounce = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (input.value.trim() !== q) return;
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<p class="ls-search-modal__empty">Niciun produs găsit pentru „' + escapeHtml(q) + '”.</p>';
              results.hidden = false;
              return;
            }
            var html = products.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) || p.image || '';
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
              return '<a class="ls-search-item" href="' + p.url + '">' +
                (img ? '<img class="ls-search-item__img" src="' + img + '" alt="" loading="lazy">' : '') +
                '<span class="ls-search-item__title">' + escapeHtml(p.title) + '</span>' +
                '<span class="ls-search-item__price">' + formatPrice(p.price) + '</span>' +
                '</a>';
            }).join('');
            html += '<a class="ls-search-modal__all" href="/search?q=' + encodeURIComponent(q) + '">Vezi toate rezultatele →</a>';
            results.innerHTML = html;
            results.hidden = false;
          })
          .catch(function () {
            // la eroare de rețea rămâne submitul clasic al formularului către /search
          });
      }, 250);
    });
  }

  setupOverlay(
    document.querySelector('[data-ls-menu-toggle]'),
    document.querySelector('[data-ls-menu]'),
    '[data-ls-menu-close]'
  );
})();
